import {
  faBook,
  faCheck,
  faFileContract,
  faLocationDot,
  faMoneyBill1Wave,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  Button,
  ButtonContainer,
  ButtonIcon,
  VacancyCard,
  Modal,
  FormContainer,
  InputWithIcon,
  InputTextWithIcon,
  SelectInputWithIcon,
} from "./AdminStyles";
import { faPlus, faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import { smartAPI } from "../../components/api/Smart";
import {
  faUser,
  faMapMarkerAlt,
  faClock,
  faTags,
  faEuroSign,
  faGraduationCap,
} from "@fortawesome/free-solid-svg-icons";

const VacancyManagement = ({ vacancies, setVacancies, onAddVacancy }) => {
  const [showModal, setShowModal] = useState(false);
  const [editingVacancy, setEditingVacancy] = useState(null);
  const [message, setMessage] = useState("");

  const [newVacancy, setNewVacancy] = useState({
    title: "",
    short_description: "",
    long_description: "",
    location: "",
    hours: "",
    salary: "",
    categories: "",
    education: "",
    experience: "",
    province: "",
    lengtitude: "",
    latitude: "",
    contract: "",
  });

  const handleChange = (e) => {
    setNewVacancy({ ...newVacancy, [e.target.name]: e.target.value });
  };

  async function fetchVacancies() {
    try {
      const response = await smartAPI({}, "GET", "vacancies");
      if (response.status === 200) {
        setVacancies(response.data);
      } else {
        setMessage("Er is iets misgegaan, probeer het opnieuw.");
      }
    } catch (error) {
      setMessage("Fout bij het verzenden, probeer later opnieuw.");
    }
  }
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newVacancy.province) {
      newVacancy.province = "alle";
    }

    try {
      let response;
      if (editingVacancy) {
        response = await smartAPI(
          newVacancy,
          "PUT",
          `vacancies/${editingVacancy.id}`
        );
      } else {
        response = await smartAPI(newVacancy, "POST", "vacancies");
      }

      if (response.status === 200 || response.status === 201) {
        setMessage(
          "Vacature succesvol " +
            (editingVacancy ? "bijgewerkt!" : "toegevoegd!")
        );
        fetchVacancies();
        setShowModal(false);
        setEditingVacancy(null);
        setNewVacancy({
          title: "",
          short_description: "",
          long_description: "",
          location: "",
          hours: "",
          salary: "",
          categories: "",
          education: "",
          experience: "",
          province: "",
          lengtitude: "",
          latitude: "",
          contract: "",
        });

        setTimeout(() => setMessage(""), 3000);
      } else if (response.status === 400 && response.data.errors) {
        // Extract error messages
        const errorMessages = Object.values(response.data.errors)
          .flat()
          .join(" ");

        setMessage(errorMessages);
      }
    } catch (error) {
      setMessage("Er is een fout opgetreden, probeer het later opnieuw.");
    }
  };

  // Open modal in edit mode with selected vacancy data
  const handleEdit = (vacancy) => {
    setEditingVacancy(vacancy);
    setNewVacancy(vacancy);
    setShowModal(true);
  };

  // Delete handler
  const handleDelete = async (id) => {
    const isConfirmed = window.confirm(
      "Weet je zeker dat je deze vacature wilt verwijderen?"
    );

    if (!isConfirmed) return;

    try {
      const response = await smartAPI({}, "DELETE", `vacancies/${id}`);
      if (response.status === 204) {
        setMessage("Vacature succesvol verwijderd!");
        setTimeout(() => setMessage(""), 3000);
        fetchVacancies();
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  return (
    <>
      {message && (
        <p
          style={{
            color: "white",
            fontWeight: "bold",
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
            backgroundColor: "#17224d",
            borderRadius: "5px",
            padding: "10px",
            border: "1px solid black",
          }}
        >
          <FontAwesomeIcon
            icon={faCheck}
            style={{ color: "green", marginRight: "10px" }}
          />
          {message}
        </p>
      )}

      <Button
        onClick={() => {
          setEditingVacancy(null);
          setNewVacancy({
            title: "",
            short_description: "",
            long_description: "",
            location: "",
            hours: "",
            salary: "",
            categories: "",
            education: "",
            experience: "",
            province: "",
            lengtitude: "",
            latitude: "",
            contract: "",
          });
          setShowModal(true);
        }}
        style={{
          backgroundColor: "oklch(0.532 0.157 131.589)",
          width: "100px",
          marginBottom: "20px",
        }}
      >
        <ButtonIcon icon={faPlus} /> Nieuw
      </Button>

      {showModal ? (
        <Modal>
          <FormContainer onSubmit={handleSubmit}>
            <h2>{editingVacancy ? "Vacature Bewerken" : "Nieuwe Vacature"}</h2>

            <InputWithIcon
              icon={faUser}
              name="title"
              placeholder="Titel"
              value={newVacancy.title}
              onChange={handleChange}
              required
            />
            <div style={{ display: "flex", gap: "20px" }}>
              <InputWithIcon
                icon={faMapMarkerAlt}
                name="location"
                placeholder="Locatie"
                value={newVacancy.location}
                onChange={handleChange}
                required
              />
              <SelectInputWithIcon
                icon={faLocationDot}
                name="province"
                placeholder="Provincie"
                value={newVacancy.province || "alle"}
                onChange={handleChange}
                required
              >
                <option value="alle">Alle provincies</option>
                <option value="groningen">Groningen</option>
                <option value="friesland">Friesland</option>
                <option value="drenthe">Drenthe</option>
                <option value="overijssel">Overijssel</option>
                <option value="flevoland">Flevoland</option>
                <option value="gelderland">Gelderland</option>
                <option value="utrecht">Utrecht</option>
                <option value="noord-holland">Noord-Holland</option>
                <option value="zuid-holland">Zuid-Holland</option>
                <option value="zeeland">Zeeland</option>
                <option value="noord-brabant">Noord-Brabant</option>
                <option value="limburg">Limburg</option>
              </SelectInputWithIcon>
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <InputWithIcon
                icon={faLocationDot}
                name="lengtitude"
                placeholder="Lengtegraad"
                value={newVacancy.lengtitude}
                onChange={handleChange}
                type="number"
              />
              <InputWithIcon
                icon={faLocationDot}
                name="latitude"
                placeholder="Breedtegraad"
                value={newVacancy.latitude}
                onChange={handleChange}
                type="number"
              />
            </div>
            <div style={{ display: "flex", gap: "20px" }}>
              <InputWithIcon
                icon={faClock}
                name="hours"
                placeholder="Uren"
                value={newVacancy.hours}
                onChange={handleChange}
                required
              />
              <InputWithIcon
                icon={faEuroSign}
                name="salary"
                placeholder="Salaris"
                value={newVacancy.salary}
                onChange={handleChange}
                required
              />
            </div>
            <InputWithIcon
              icon={faFileContract}
              name="contract"
              placeholder="Dienstverband"
              value={newVacancy.contract}
              onChange={handleChange}
              required
            />
            <InputWithIcon
              icon={faBook}
              name="short_description"
              placeholder="Korte beschrijving"
              value={newVacancy.short_description}
              onChange={handleChange}
              required
            />
            <InputTextWithIcon
              name="long_description"
              placeholder="Uitgebreide beschrijving"
              value={newVacancy.long_description}
              onChange={handleChange}
              icon={faBook}
              required
            />
            <InputWithIcon
              icon={faTags}
              name="categories"
              placeholder="Categorieën"
              value={newVacancy.categories}
              onChange={handleChange}
              required
            />
            <InputWithIcon
              icon={faGraduationCap}
              name="education"
              placeholder="Opleiding"
              value={newVacancy.education}
              onChange={handleChange}
              required
            />
            <InputWithIcon
              icon={faGraduationCap}
              name="experience"
              placeholder="Ervaring"
              value={newVacancy.experience}
              onChange={handleChange}
              required
            />

            <Button type="submit" style={{ width: "100%" }}>
              {editingVacancy ? "Vacature Bijwerken" : "Vacature Toevoegen"}
            </Button>
            <Button
              type="button"
              onClick={() => setShowModal(false)}
              style={{ width: "100%" }}
            >
              Annuleren
            </Button>
          </FormContainer>
        </Modal>
      ) : (
        <div className="vacancy-row">
          {vacancies.map((vacancy) => (
            <VacancyCard key={vacancy.id} style={{ paddingLeft: "20px" }}>
              <h3>{vacancy.title}</h3>
              <p>{vacancy.short_description}</p>
              <span>
                <FontAwesomeIcon
                  icon={faLocationDot}
                  style={{ marginRight: "8px" }}
                />
                <strong>Locatie:</strong> {vacancy.location}
              </span>

              <div>
                <FontAwesomeIcon
                  icon={faClock}
                  style={{ marginRight: "8px" }}
                />
                <strong>Uren:</strong> {vacancy.hours}
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faMoneyBill1Wave}
                  style={{ marginRight: "8px" }}
                />
                <strong>Salaris:</strong> {vacancy.salary}
              </div>
              <div>
                <FontAwesomeIcon icon={faTags} style={{ marginRight: "8px" }} />
                <strong>Categorieën:</strong> {vacancy.categories}
              </div>
              <div>
                <FontAwesomeIcon
                  icon={faGraduationCap}
                  style={{ marginRight: "8px" }}
                />
                <strong>Opleiding:</strong> {vacancy.education}
              </div>
              <ButtonContainer>
                <Button onClick={() => handleEdit(vacancy)}>
                  <ButtonIcon icon={faPen} /> Bewerken
                </Button>
                <Button
                  style={{ backgroundColor: "oklch(0.637 0.237 25.331)" }}
                  onClick={() => handleDelete(vacancy.id)}
                >
                  <ButtonIcon icon={faTrash} /> Verwijderen
                </Button>
              </ButtonContainer>
            </VacancyCard>
          ))}
        </div>
      )}
    </>
  );
};

export default VacancyManagement;
